module.exports = __webpack_public_path__ + "static/img/dataset_banner.958b185.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/dataset_banner.jpg
// module id = S5T4
// module chunks = 5